import { motion } from "framer-motion";
import { useLocale } from "../i18n/LocaleContext";

export function BusinessScopeSection() {
  const { copy, locale } = useLocale();
  const { businessScope } = copy;
  const isChinese = locale === "zh" || locale === "vi";

  return (
    <section className="px-5 py-22 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 grid gap-6 lg:grid-cols-[0.78fr_1.22fr] lg:items-end">
          <div>
            <p className="text-sm uppercase tracking-[0.38em] text-aurora/80">
              {businessScope.eyebrow}
            </p>
            <h2
              className={`mt-4 max-w-[34rem] leading-[1.05] text-[#1f2b31] ${
                isChinese
                  ? "font-sans text-[2.15rem] font-medium tracking-[-0.01em] sm:text-[3rem]"
                  : "font-display text-4xl font-semibold sm:text-5xl"
              }`}
            >
              {businessScope.title}
            </h2>
          </div>
          <p className="max-w-[17rem] text-[0.9rem] leading-7 text-soft/58 lg:justify-self-end">
            {businessScope.body}
          </p>
        </div>

        <div className="grid gap-5 md:grid-cols-2">
          {businessScope.items.map((item, index) => (
            <motion.article
              key={item.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.55, delay: index * 0.06 }}
              className="group rounded-[2.3rem] border border-[#dce8ee] bg-[linear-gradient(180deg,rgba(252,254,255,0.9),rgba(239,246,249,0.95))] p-7 shadow-[0_12px_24px_rgba(106,138,151,0.05)] transition hover:-translate-y-1 hover:bg-[linear-gradient(180deg,rgba(255,255,255,0.99),rgba(242,248,251,0.99))] hover:shadow-[0_16px_30px_rgba(106,138,151,0.07)]"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#eaf4f7] text-[11px] font-semibold tracking-[0.16em] text-[#698592] shadow-[inset_0_0_0_1px_rgba(122,164,178,0.18)]">
                0{index + 1}
              </div>
              <div className="mt-7 text-[10px] uppercase tracking-[0.24em] text-aurora/74">
                {businessScope.scopeLabel}
              </div>
              <h3
                className={`mt-4 max-w-[16rem] leading-tight text-[#1f2b31] ${
                  isChinese ? "font-sans text-[1.56rem] font-medium" : "font-display text-[1.82rem]"
                }`}
              >
                {item.title}
              </h3>
              <p className="mt-5 max-w-[20rem] text-[0.9rem] leading-7 text-soft/58">{item.body}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
